import React from "react";
import * as icons from "../../../libs/icons";
import { iconTypes } from "../../../libs/icons/index.d";

export interface IconProps {
  refIcon: iconTypes;
  color?: string;
  size?: number;
  onClick?: () => void;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({
  refIcon,
  color,
  size,
  onClick,
  className,
}) => (
  <div
    className={className || "icon-container"}
    onClick={onClick}
    style={{
      width: size,
      height: size,
      fill: color,
    }}
  >
    {React.createElement(icons[refIcon], {})}
  </div>
);
